import {
	isset
} from '../func/_general';

export const TYPE_BARS = 'bars';

export const build = (options) => {

	let message__html = '';
	let spinner__html = '';
	let type = TYPE_BARS;

	if(isset(options)) {
		if(isset(options.type)) {
			type = options.type;
		}
		if(isset(options.message)) {
			message__html = '<div class="message">'+options.message+'</div>';
		}
	}
	
	switch(type) {
		case 'bars':
			const nob = 5;
			for (let i = 0; i < nob; i++) {
				spinner__html = spinner__html.concat('<div class="rect'+(i+1)+'"></div>');
			}
			break;
		default:;
	}


	var loader__html = ''.concat(
		'<div class="vd-loader">',
			'<div class="vd-loader__wrapper">',
				'<div class="spinner">',
					spinner__html,
				'</div>',
				message__html,
			'</div>',
		'</div>'
	);

	return loader__html;
};